// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"374":"9b4a7db8","381":"2b02d4b0","542":"090acf81","545":"79cf8bd5","656":"a0b37e6a","989":"8d7f4b04"}[chunkId] + ".chunk.css";
};